import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Zap, Coffee, Battery } from 'lucide-react';
export function MorningEnergyChart() {
  const [hoveredBar, setHoveredBar] = useState<string | null>(null);
  const energyData = [{
    product: 'LyraSleep',
    energy: 95,
    color: 'from-green-400 to-emerald-500',
    icon: Zap,
    description: 'Wake up refreshed and energized',
    benefits: ['No grogginess', 'Clear mind', 'Full energy']
  }, {
    product: 'Melatonin',
    energy: 55,
    color: 'from-yellow-400 to-orange-400',
    icon: Coffee,
    description: 'Moderate grogginess, needs coffee',
    benefits: ['Mild fog', 'Needs caffeine', 'Slow start']
  }, {
    product: 'Ambien',
    energy: 35,
    color: 'from-red-400 to-red-500',
    icon: Battery,
    description: 'Heavy grogginess and brain fog',
    benefits: ['Heavy fog', 'Sluggish', 'Hangover feeling']
  }];
  return <div className="my-16 bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 border-2 border-green-100" data-id="element-288">
      <div className="text-center mb-8" data-id="element-289">
        <div className="inline-flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-full text-sm font-bold mb-4" data-id="element-290">
          <Zap className="w-4 h-4" data-id="element-291" />
          MORNING ENERGY COMPARISON
        </div>
        <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-292">
          Wake Up Feeling Actually Rested
        </h3>
        <p className="text-gray-600" data-id="element-293">
          How you feel the morning after — no grogginess, no fog
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-294">
        {energyData.map((item, index) => {
        const Icon = item.icon;
        return <motion.div key={item.product} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.2
        }} onMouseEnter={() => setHoveredBar(item.product)} onMouseLeave={() => setHoveredBar(null)} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all cursor-pointer" data-id="element-295">
              <div className="flex items-center justify-between mb-4" data-id="element-296">
                <div className="flex items-center gap-2" data-id="element-297">
                  <div className={`w-10 h-10 rounded-full bg-gradient-to-r ${item.color} flex items-center justify-center`} data-id="element-298">
                    <Icon className="w-5 h-5 text-white" data-id="element-299" />
                  </div>
                  <div data-id="element-300">
                    <div className="font-bold text-gray-900" data-id="element-301">
                      {item.product}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-302">Morning Energy</div>
                  </div>
                </div>
                <motion.div className="text-3xl font-bold bg-gradient-to-r from-gray-700 to-gray-900 bg-clip-text text-transparent" initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              delay: 0.5 + index * 0.2,
              type: 'spring'
            }} data-id="element-303">
                  {item.energy}
                </motion.div>
              </div>

              {/* Energy Bar */}
              <div className="relative h-32 bg-gray-100 rounded-lg overflow-hidden mb-4" data-id="element-304">
                <motion.div className={`absolute bottom-0 left-0 right-0 bg-gradient-to-t ${item.color} rounded-lg`} initial={{
              height: 0
            }} animate={{
              height: `${item.energy}%`
            }} transition={{
              delay: 0.8 + index * 0.2,
              duration: 1,
              ease: 'easeOut'
            }} data-id="element-305" />
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-306">
                  <motion.div initial={{
                opacity: 0
              }} animate={{
                opacity: hoveredBar === item.product ? 1 : 0
              }} className="text-white font-bold text-lg drop-shadow-lg" data-id="element-307">
                    {item.energy}%
                  </motion.div>
                </div>
              </div>

              <p className="text-sm text-gray-600 mb-3" data-id="element-308">{item.description}</p>

              <div className="space-y-1" data-id="element-309">
                {item.benefits.map((benefit, i) => <div key={i} className="flex items-center gap-2 text-xs text-gray-500" data-id="element-310">
                    <div className={`w-1.5 h-1.5 rounded-full bg-gradient-to-r ${item.color}`} data-id="element-311" />
                    {benefit}
                  </div>)}
              </div>

              {item.product === 'LyraSleep' && <div className="mt-4 bg-green-50 border border-green-200 rounded-lg px-3 py-2" data-id="element-312">
                  <div className="flex items-center gap-2" data-id="element-313">
                    <Zap className="w-4 h-4 text-green-600" data-id="element-314" />
                    <span className="text-xs font-semibold text-green-700" data-id="element-315">
                      Best Morning Energy
                    </span>
                  </div>
                </div>}
            </motion.div>;
      })}
      </div>

      {/* Comparison Summary */}
      <div className="bg-white rounded-xl p-6 shadow-lg" data-id="element-316">
        <div className="grid md:grid-cols-3 gap-4 text-center" data-id="element-317">
          <div data-id="element-318">
            <div className="text-3xl font-bold text-green-600 mb-1" data-id="element-319">2.7x</div>
            <div className="text-sm text-gray-600" data-id="element-320">
              More energized than Melatonin
            </div>
          </div>
          <div data-id="element-321">
            <div className="text-3xl font-bold text-green-600 mb-1" data-id="element-322">0</div>
            <div className="text-sm text-gray-600" data-id="element-323">Morning grogginess</div>
          </div>
          <div data-id="element-324">
            <div className="text-3xl font-bold text-green-600 mb-1" data-id="element-325">100%</div>
            <div className="text-sm text-gray-600" data-id="element-326">Natural wake-up feeling</div>
          </div>
        </div>
      </div>
    </div>;
}